import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, LayerGroup, Popup, AttributionControl, Tooltip, GeoJSON, LayersControl, useMapEvents } from "react-leaflet";
import { GestureHandling } from "leaflet-gesture-handling";
import LayerControl from '../map/layer-control';

import { generateIcon } from '../map/marker';

const Map = ({ data, defaultCentre = [-41.2924, 174.7787], defaultZoom = 6 }) => {


  return (
    <output>
      <MapContainer
        className="markercluster-map"
        center={defaultCentre}
        zoom={defaultZoom}
        maxZoom={18}
        attributionControl={false}
        whenReady={({ target:map }) => {
          map.gestureHandling.enable();

          // a11y (?) move the controls above the map in the source order
          const mapPane = document.querySelector('.leaflet-map-pane');
          const controls = document.querySelector('.leaflet-control-container');
          mapPane.before(controls);
        }}
      >
        <LayerControl />
        {data.filter(({ latitude, longitude }) => latitude && longitude).map(item => (
          <MarkerWithState item={item} />
        ))}
        <AttributionControl position="bottomright" prefix={false} />
      </MapContainer>
    </output>
  )
}

export default Map;


const MarkerWithState = ({ item, ...props }) => {
  const [ isOpen, setIsOpen ] = useState(false);

  return (
    <Marker
      eventHandlers={{
        popupopen: (e) => setIsOpen(true),
        popupclose: (e) => setIsOpen(false),
      }}
      icon={item.status === 'open' ? generateIcon('teal', `Open ${item.title}`, isOpen) : generateIcon('grey', `Open ${item.title}`, isOpen)}
      keyboard={false}
      position={[item.latitude, item.isCloseToAntimeridian ? item.longitude + 360 : item.longitude]}>
        <Popup>
          <a href={item.view_node}>{item.title}</a>
            {/*<p>{item.status}</p>*/}
        </Popup>
    </Marker>
  )
}